var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/* istanbul ignore file */
import * as React from "react";
import * as CMP from "../components";
import { observer } from "mobx-react";
import { JackpotDefaultBlockState } from "../state";
import { rootDataRetriever } from "../../../data";
import { BaseDict, DictContextProvider } from "../dict";
import { store } from "../../../data/store";
let JackpotDefaultBlock = class JackpotDefaultBlock extends React.Component {
    constructor(props) {
        super(props);
        this.dict = Object.assign(Object.assign({}, BaseDict), (props.dict || {}));
        this.dataRetriever = props.dataRetriever || rootDataRetriever;
        let jackpotId = props.cms.JackpotId, incrementPeriod = Number(props.cms.IncrementPeriod), incrementValue = Number(props.cms.IncrementValue) / 100;
        let jackpot = this.dataRetriever.activateFor(jackpotId, props.isAvailableCallbackFn, incrementPeriod, incrementValue);
        this.state = {
            dataProvider: new JackpotDefaultBlockState(jackpot, props.cms, props.config)
        };
        //update jackpot for promotion popup as we should show latest value
        props.config && props.config.forPopup && this.dataRetriever.updateJackpot(jackpot.id);
    }
    render() {
        let { jackpotBlockData, datePartConfig, tickerConfig } = this.state.dataProvider;
        let clickHandler = () => {
            jackpotBlockData.setShowPopup(true);
            jackpotBlockData.showPopup && this.dataRetriever.updateJackpot(jackpotBlockData.jackpotId);
        };
        return (React.createElement(React.Fragment, null,
            React.createElement(DictContextProvider, { value: this.dict },
                React.createElement("a", { className: "rj-jackpot__item", onClick: clickHandler, id: `rj-jackpot__item-${this.props.cms.Id}` },
                    React.createElement(CMP.JackpotItem, { jackpot: jackpotBlockData, datePartConfig: datePartConfig, tickerConfig: tickerConfig, usedAsPartOfBlock: this.props.usedAsPartOfBlock })),
                jackpotBlockData.showPopup && React.createElement(CMP.JackpotPopup, { jackpot: jackpotBlockData, isUserLoggedIn: store.isUserLoggedIn }))));
    }
};
JackpotDefaultBlock = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], JackpotDefaultBlock);
export { JackpotDefaultBlock };
window["JackpotComponent"] = JackpotDefaultBlock;
//# sourceMappingURL=JackpotDefaultBlock.js.map